import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import Ranking from "./components/Ranking";
import TopWorks from "./components/TopWorks";
import Updates from "./components/Updates";
import Weekly from "./components/Weekly";
import Categories from "./components/Categories";
import FAQ from "./components/FAQ";
import About from "./components/About";
import Contact from "./components/Contact";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Ranking />
        <TopWorks />
        <Updates />
        <Weekly />
        <Categories />
        <FAQ />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}